import { BaseURL } from '../../config';

export const FETCH_WIDGET_DATA_API = `${BaseURL}/app/csvupload/widget`;
export const FETCH_LOCATIONS_API = `${BaseURL}/app/locations`;
export const FETCH_CSV_UPLOAD_URL_API = `${BaseURL}/app/csvupload`;
export const FETCH_CSV_AUTH_TOKEN_API = `${BaseURL}/app/csvupload/authtoken`;
export const FETCH_CSV_UPLOAD_STATUS_API = `${BaseURL}/app/csvupload/status`;
export const FETCH_DOWNLOAD_CATALOGUE_API = `${BaseURL}/app/catalog`;
export const FETCH_DOWNLOAD_CATALOGUE_STATUS_API = `${BaseURL}/app/catalog/status`;
export const FETCH_APP_ORDER_API = `${BaseURL}/app/order`;
export const CREATE_DRAFT_ORDER_API = `${BaseURL}/app/csvupload/draftorder`;
export const FETCH_SEARCH_PRODUCTS_API = `${BaseURL}/app/csvupload/search`;

export const statusRequestInterval = 3000;
export const rowsPerPage = 5;
export const maxPossibleItemQty = 999999;
